import { generateClient } from "aws-amplify/api";
import { updateProject } from "../graphql/mutations";
import { recordSentry } from "./recordSentry";
import { Project, ProjectForResolver } from "db/definitions";

async function handleProjectUpdate(newProject: Project | ProjectForResolver) {
	try {
		const updatedProject = {
			id: newProject.id,
			users: newProject.users,
			name: newProject.name,
			group: newProject.group,
			public: newProject.public,
			forceUpdateData: newProject.forceUpdateData,
		};
		const client = generateClient({ authMode: "userPool" });
		await client.graphql({
			query: updateProject,
			variables: {
				input: updatedProject,
			},
			authMode: "userPool",
		});
	} catch (error) {
		recordSentry({ error, msg: "Error updating project: " });
	}
}

export default handleProjectUpdate;
